import { ofType } from 'redux-observable';
import { switchMap } from 'rxjs/operators/switchMap';
import { from } from 'rxjs/observable/from';
import { catchError } from 'rxjs/operators/catchError';
import { retryAuthentication } from '../../utils/epics/retryAuthentication';

import {
  types as actions,
  setTagsAction,
  getZonesBySiteAction,
  getLocationsBySiteAction,
  getCategoriesAction,
  getGroupsAction,
  getFiltersAction
} from '../../reducers/actions';
import { TagService } from '../../services';

export default function(action$, store) {
  return action$.pipe(
    ofType(actions.GET_TAGS),
    switchMap(action => {
      return TagService.getBySiteId(action.siteId, action.page, action.size, action.searchText, action.sorting, action.filters, action.areaId).pipe(
        switchMap(tags => {
          const firstPageLoaded = store.getState().tags.firstPageLoaded;
          if (firstPageLoaded) {
            return from([
              setTagsAction(tags)
            ])
          }
          else {
            return from([
              setTagsAction(tags),
              getZonesBySiteAction(action.siteId),
              getLocationsBySiteAction(action.siteId),
              getCategoriesAction(action.siteId),
              getGroupsAction(action.siteId),
              getFiltersAction(action.siteId),
            ]);
          }
        }),
        catchError(retryAuthentication(action$, 'epics/tags/getTags'))
      );
    })
  );
}



// WEBPACK FOOTER //
// ./src/epics/tags/getTags.js